"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VektorioProjects = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
require("./index.scss");
var NoProjects_1 = require("./components/NoProjects");
var ProjectTabs_1 = require("./components/ProjectTabs");
var dispatchers_1 = require("./utils/dispatchers");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var getProjectsState = function (state) { return state.vektorio.projects; };
var VektorioProjects = function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var projectsState = (0, react_redux_1.useSelector)(getProjectsState);
    var fetchProjects = function () { return dispatchers.fetchProjects(props.currentProject); };
    var unmount = function () {
        dispatchers.clear();
    };
    var mount = function () {
        fetchProjects();
        return unmount;
    };
    React.useEffect(mount, []);
    if (projectsState.status.isStandby || projectsState.status.isBusy) {
        return (React.createElement("div", { className: 'center' },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    else if (projectsState.status.isFailure) {
        return (React.createElement("div", { className: 'center' },
            React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: 'vektorio/emptyList/title', message: (0, translation_1.getLocalization)('vektorio/emptyList/message') })));
    }
    else if (projectsState.list.length === 0) {
        return React.createElement(NoProjects_1.NoProjects, null);
    }
    return (React.createElement(ProjectTabs_1.ProjectTabs, { currentProject: props.currentProject, vektorioProjects: projectsState.list }));
};
exports.VektorioProjects = VektorioProjects;
